const VisitPlan = () => import('@/views/VisitPlan')
const VisitPlanDetail = () => import('@/views/VisitPlan/detail')
const visitPlanRouter = [
  {
    path: '/visitPlan',
    component: VisitPlan,
    meta: {
      title: 'Visit Plan'
    }
  },
  {
    path: '/visitPlan/detail',
    component: VisitPlanDetail,
    meta: {
      title: ''
    }
  }
]

export default visitPlanRouter
